export default __webpack_public_path__ + "static/media/Thejus Jawahar.4863bc22.jpg";